import { Form } from '../core';

$.fn.NewsletterForm = function () {
  let self = this;

  self.initialize_form = function () {
    new Form('.newsletter-form', {
      ajax_redirect: false,
      auto_scroll: true,
      auto_scroll_offset: $('header').outerHeight(false) + 20,
      floating_labels: true,
      onSubmit: function () {
        $('.newsletter-form').addClass('newsletter-form--blocked');
      },
      onSuccess: function () {
        self.fadeOut(250, function () {
          let $success = $('<p class="form-success">');
          // $success.text(script_l10n.DOUBLE_OPTIN).hide()
          self.after($success);
          requestAnimationFrame(function () {
            self.remove();
            $success.fadeIn(250);
          });
        });
      },
      onError: function () {
        requestAnimationFrame(function () {
          $('.newsletter-form').removeClass('newsletter-form--blocked');
          $('.newsletter-form .form-error--invisible').removeClass('form-error--invisible');
          $('.newsletter-form .field-error--invisible').removeClass('field-error--invisible');
        });
      }
    });
  };

  return (function () {
    self.initialize_form();
    return self;
  })();
};
